import React from 'react';
import Icon1 from '../img/icon-1.png'
import Icon2 from '../img/icon-2.png'
import Icon3 from '../img/icon-3.png'
import Icon4 from '../img/icon-4.png'
import Icon5 from '../img/icon-5.png'
import Icon6 from '../img/icon-6.png'
import Icon7 from '../img/icon-7.png'
import Icon8 from '../img/icon-8.png'
import Icon9 from '../img/icon-9.png'
import Icon10 from '../img/icon-10.png'
import Icon11 from '../img/icon-11.png'
import Icon12 from '../img/icon-12.png'
import './skills.scss'

const Skills = () => {
	const skills = [
		{ id: 1, IconImage: Icon1, IconName: 'HTML' },
		{ id: 2, IconImage: Icon2, IconName: 'CSS' },
		{ id: 3, IconImage: Icon3, IconName: 'JavaScript' },
		{ id: 4, IconImage: Icon4, IconName: 'React JS' },
		{ id: 5, IconImage: Icon5, IconName: 'PHP' },
		{ id: 6, IconImage: Icon6, IconName: 'Node JS' },
		{ id: 7, IconImage: Icon7, IconName: 'MongoDB' },
		{ id: 8, IconImage: Icon8, IconName: 'MySQL' },
		{ id: 9, IconImage: Icon9, IconName: 'GitHub' },
		{ id: 10, IconImage: Icon10, IconName: 'VS Code' },
		{ id: 11, IconImage: Icon11, IconName: 'Postman' },
		{ id: 12, IconImage: Icon12, IconName: 'Git' }
	];
	
	return (
		<div className="mainSkills">
			<div className="subSkills">
				<h3>Skills</h3>
				<div className="FrontendSkills">
					{skills.map((skill) => (
						<div key={skill.id} className="skillCard">
							<img src={skill.IconImage} alt={skill.IconName} />
							<p>{skill.IconName}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Skills;
